document.addEventListener("DOMContentLoaded", function () {
  const swiper_coll = new Swiper(".swiper-slider-mobile", {
    loop: true,
    pagination: {
      el: ".swiper-pagination-coll",
      clickable: true,
    },
    centeredSlides: true,
    slidesPerView: 5.4,
    spaceBetween: 20,
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 14,
      },
      575: {
        slidesPerView: 1.2,
        spaceBetween: 14,
      },
    },
  });
});
